<template>
  <v-app>
    <v-main>
      <v-container class="mx-auto">
        <p class="text-center">
          {{ $t("forbidden") }}
        </p>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "PageForbidden",
});
</script>
